import { TECHNICIAN_ERROR_MESSAGES } from '../errors';

export const validateName = (name: string): string => {
  if (!name.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validatePhone = (phone: string): string => {
  if (!phone.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  const digitsOnly = phone.replace(/\D/g, '');
  if (digitsOnly.length < 9) {
    return TECHNICIAN_ERROR_MESSAGES.PHONE_MIN_LENGTH;
  }
  if (digitsOnly.length > 9) {
    return 'Numer telefonu może mieć maksymalnie 9 cyfr';
  }
  return '';
};

export const validateEmail = (email: string): string => {
  if (!email.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email.trim())) {
    return TECHNICIAN_ERROR_MESSAGES.EMAIL_INVALID_FORMAT;
  }
  return '';
};

export const validateAddress = (address: string): string => {
  if (!address.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateCity = (city: string): string => {
  if (!city.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateState = (state: string): string => {
  if (!state.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateCountry = (country: string): string => {
  if (!country.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateCountryCode = (code: string): string => {
  if (!code.trim()) {
    return TECHNICIAN_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateZip = (zip: string): string => {
  if (!zip.trim()) {
    return '';
  }
  const zipRegex = /^\d{2}-\d{3}$/;
  if (!zipRegex.test(zip.trim())) {
    return TECHNICIAN_ERROR_MESSAGES.ZIP_INVALID_FORMAT;
  }
  return '';
};
